import {
  SUFFIX_ANCHOR_SELECTOR,
  SUFFIX_CONTAINER_CLASS,
  SUFFIX_CONTAINER_MARGIN_LEFT,
} from '@Components/ai-chat-window/components/markdown-renderer/markdown-renderer.types';

function buildSuffixContainer(): HTMLSpanElement {
  const container = document.createElement('span');
  container.className = SUFFIX_CONTAINER_CLASS;
  container.style.display = 'inline';
  container.style.marginLeft = SUFFIX_CONTAINER_MARGIN_LEFT;

  return container;
}

function removeStaleSuffixContainers(body: Element): void {
  body.querySelectorAll(`.${SUFFIX_CONTAINER_CLASS}`).forEach((stale) => {
    stale.remove();
  });
}

function lastAnchorInsideFinalBlock(body: Element): HTMLElement | null {
  const anchors = body.querySelectorAll<HTMLElement>(SUFFIX_ANCHOR_SELECTOR);
  const lastAnchor = anchors[anchors.length - 1] ?? null;

  if (!lastAnchor || !body.lastElementChild?.contains(lastAnchor)) {
    return null;
  }

  return lastAnchor;
}

export function attachSuffixContainer(body: Element): HTMLSpanElement {
  removeStaleSuffixContainers(body);

  const container = buildSuffixContainer();
  const anchor = lastAnchorInsideFinalBlock(body);

  if (anchor) {
    anchor.appendChild(container);

    return container;
  }

  body.appendChild(container);

  return container;
}

/**
 * Strips leading indentation from HTML-tag lines so pretty-printed HTML from the agent isn't parsed as a markdown code block.
 * Only lines whose first non-space character is `<` are de-indented, leaving markdown lists and prose untouched.
 */
export function deindentHtmlLines(content: string): string {
  return content.replace(/^[ \t]+(?=<)/gm, '');
}
